<template>
	<OrganismSlideshow
		class="uppercase italic"
		v-bind="$props"
	>
		<div class="relative flex flex-col md:flex-row gap-8">
			<AtomButton
				class="uppercase italic !font-bold"
				:variant="ButtonVariant.Green"
				size="xl"
				text="Gratis meedoen"
				icon-left="fa-bolt"
				:to="{
					url: '/small-group-training/aanmelden-proefles',
					title: 'Gratis Small Group Training proefles',
				}"
				@click="trackButtonClick('Slideshow_CTA_Trial')"
			/>
			<AtomButton
				class="uppercase italic !font-bold"
				:variant="ButtonVariant.LightBorder"
				size="xl"
				text="Small Group Training"
				icon-left="fa-users"
				:to="{
					url: '/small-group-training',
					title: 'Small Group Training',
				}"
				@click="trackButtonClick('Slideshow_CTA_SGT')"
			/>
		</div>
	</OrganismSlideshow>
</template>

<script setup lang="ts">
import OrganismSlideshow from '#base/app/components/organism/Slideshow.vue';
import type { ImageType } from '#base/core/types/ImageType';
import type { SlideType } from '#base/core/types/SlideType';
import type { VideoType } from '#base/core/types/VideoType';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const slideInterval = ref<NodeJS.Timeout | string | number | undefined>();
const currentSlide = ref(0);
const slideRef = ref();

defineProps<{
	slides: SlideType[];
	backgroundImage?: ImageType;
	backgroundVideo?: VideoType;
}>();

const { trackButtonClick } = useEventTracking();

function setNextSlide() {
	if (slideRef?.value && currentSlide.value + 1 < slideRef.value.length) {
		currentSlide.value++;
	}
	else {
		currentSlide.value = 0;
	}
}

onMounted(() => {
	slideInterval.value = setInterval(() => {
		setNextSlide();
	}, 7000);
});

onUnmounted(() => {
	clearInterval(slideInterval.value);
});
</script>
